var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import { useUniqueInlineId } from '@inline-svg-unique-id/react';
import * as React from "react";
function SvgSendPushNotification(props) {
  var _id = useUniqueInlineId();
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#".concat(_id, ")")
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.667 5.331v15.2a3.995 3.995 0 01-3.995 3.996h-3.808a1.355 1.355 0 00-1.02.463l-4.77 5.468c-.4.452-1.074.135-1.074-.51v-4.066a1.355 1.355 0 00-1.355-1.355H5.329a3.995 3.995 0 01-3.996-3.995v-15.2A3.995 3.995 0 015.33 1.335h21.343a3.995 3.995 0 013.995 3.995z",
    fill: "#FF9F40"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16 1.336v24.546a1.355 1.355 0 00-1.355-1.355H5.329a3.995 3.995 0 01-3.996-3.995v-15.2A3.995 3.995 0 015.33 1.335H16z",
    fill: "#FFB459"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.327 3.34l-3.063 3.145a1.76 1.76 0 01-1.255.528h-6.97a3.18 3.18 0 00-3.173 3.174 3.174 3.174 0 003.174 3.173h6.94a1.758 1.758 0 011.244.528l3.109 3.162a.587.587 0 00.956-.393V3.751a.586.586 0 00-.962-.41z",
    fill: "#fff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.653 14.328h-1.76a1.531 1.531 0 00-1.52 1.308l-.908 6.072a.587.587 0 00.586.646h1.76a1.531 1.531 0 001.52-1.303l.91-6.072a.586.586 0 00-.588-.65zM16.24 14.329h-.51a.903.903 0 00-.903.774l-.534 3.584a.34.34 0 00.334.388h.505a.903.903 0 00.897-.775l.558-3.59a.334.334 0 00-.346-.382zM25.387 7.913a2.652 2.652 0 00-1.884-.78.276.276 0 00-.275.276v5.585a.269.269 0 00.275.27 2.669 2.669 0 002.67-2.664v-.798a2.64 2.64 0 00-.786-1.889z",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: _id
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(1.333 1.336)",
    d: "M0 0h29.333v29.333H0z"
  })))));
}
export default SvgSendPushNotification;